import FEMALEREPVSMALEBYROLE from 'data/mantechcar24/female-representation-vs-male-by-role.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import React from 'react';
import {
  Layer,
  Rectangle,
  ResponsiveContainer,
  Sankey,
  Tooltip
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const FemalesVsMalesByRole: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  const CustomNode = ({ x, y, height, index, payload }: any): any => {
    return (
      <Layer key={`CustomNode${index}`}>
        <Rectangle
          x={x}
          y={y}
          width={20}
          height={height}
          fill={payload.fill}
          fillOpacity="1"
        />
        <text
          textAnchor="start"
          x={x + 26}
          y={y + height / 2}
          fontSize="14"
          fill="#837E93"
        >
          {t(payload.name)}
        </text>
        <text
          textAnchor="start"
          x={x + 26}
          y={y + height / 2 + 14}
          fontSize="12"
          stroke="#1F1D26"
          strokeOpacity="0.5"
        >
          {payload.value.toLocaleString(locale)}
        </text>
      </Layer>
    );
  };

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={600} width="99%" minWidth={500}>
          <Sankey
            data={FEMALEREPVSMALEBYROLE}
            node={<CustomNode />}
            nodePadding={25}
            margin={{
              top: 10,
              right: 200,
              bottom: 50
            }}
            link={{ stroke: '#17BECF' }}
          >
            <Tooltip />
          </Sankey>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default FemalesVsMalesByRole;
